// State
const state = {
  isOpen: false,
  isCopySignModalOpen: false,
  isExhibitionModalOpen: false,
  isShoppingCartOverviewModalOpen: false,
  isSignModalOpen: false,
  isSloganModalOpen: false,
  isUserModalOpen: false,
  isVariantModalOpen: false
}

// Mutations
export const closeModals = 'closeModals'
export const openAddSignToShoppingCartModal = 'openAddSignToShoppingCartModal'
export const closeAddSignToShoppingCartModal = 'closeAddSignToShoppingCartModal'
export const openExhibitionModal = 'openExhibitionModal'
export const closeExhibitionModal = 'closeExhibitionModal'
export const openShoppingCartOverviewModalOpen =
  'openShoppingCartOverviewModalOpen'
export const closeShoppingCartOverviewModalOpen =
  'closeShoppingCartOverviewModalOpen'
export const openSignModal = 'openSignModal'
export const closeSignModal = 'closeSignModal'
export const openSloganModal = 'openSloganModal'
export const closeSloganModal = 'closeSloganModal'
export const openTransferModal = 'openTransferModal'
export const closeTransferModal = 'closeTransferModal'
export const openUserModal = 'openUserModal'
export const closeUserModal = 'closeUserModal'
export const openVariantModal = 'openVariantModal'
export const closeVariantModal = 'closeVariantModal'
export const openCopySignModal = 'openCopySignModal'
export const closeCopySignModal = 'closeCopySignModal'

const mutations = {
  [closeModals] (state) {
    state.isAddSignToShoppingCartModalOpen = false
    state.isCopySignModalOpen = false
    state.isExhibitionModalOpen = false
    state.isUserModalOpen = false
    state.isShoppingCartOverviewModalOpen = false
    state.isSignModalOpen = false
    state.isSloganModalOpen = false
    state.isTransferModalOpen = false
    state.isVariantModalOpen = false
    state.isOpen = false
  },
  [openAddSignToShoppingCartModal] (state) {
    state.isAddSignToShoppingCartModalOpen = true
    state.isOpen = true
  },
  [closeAddSignToShoppingCartModal] (state) {
    state.isAddSignToShoppingCartModalOpen = false
    state.isOpen = false
  },
  [openCopySignModal] (state) {
    state.isCopySignModalOpen = true
    state.isOpen = true
  },
  [closeCopySignModal] (state) {
    state.isCopySignModalOpen = false
    state.isOpen = false
  },
  [openExhibitionModal] (state) {
    state.isExhibitionModalOpen = true
    state.isOpen = true
  },
  [closeExhibitionModal] (state) {
    state.isExhibitionModalOpen = false
    state.isOpen = false
  },
  [openShoppingCartOverviewModalOpen] (state) {
    state.isShoppingCartOverviewModalOpen = true
    state.isOpen = true
  },
  [closeShoppingCartOverviewModalOpen] (state) {
    state.isShoppingCartOverviewModalOpen = false
    state.isOpen = false
  },
  [openSignModal] (state) {
    state.isSignModalOpen = true
    state.isOpen = true
  },
  [closeSignModal] (state) {
    state.isSignModalOpen = false
    state.isOpen = false
  },
  [openSloganModal] (state) {
    state.isSloganModalOpen = true
    state.isOpen = true
  },
  [closeSloganModal] (state) {
    state.isSloganModalOpen = false
    state.isOpen = false
  },
  [openTransferModal] (state) {
    state.isTransferModalOpen = true
    state.isOpen = true
  },
  [closeTransferModal] (state) {
    state.isTransferModalOpen = false
    state.isOpen = false
  },
  [openUserModal] (state) {
    state.isUserModalOpen = true
    state.isOpen = true
  },
  [closeUserModal] (state) {
    state.isUserModalOpen = false
    state.isOpen = false
  },
  [openVariantModal] (state) {
    state.isVariantModalOpen = true
    state.isOpen = true
  },
  [closeVariantModal] (state) {
    state.isVariantModalOpen = false
    state.isOpen = false
  }
}

// Actions
const actions = {}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/modals.js